import React, { useState } from 'react';

const APP_PIN = process.env.REACT_APP_PIN || 'scouting';
const STORAGE_KEY = 'sn_gate_ok';

export function isGateOpen() {
  return localStorage.getItem(STORAGE_KEY) === 'true';
}

export default function AppGate({ onUnlock }) {
  const [pin, setPin]     = useState('');
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    if (pin === APP_PIN) {
      localStorage.setItem(STORAGE_KEY, 'true');
      onUnlock();
    } else {
      setError(true);
      setShake(true);
      setPin('');
      setTimeout(() => setShake(false), 600);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: 'var(--bg)', padding: 24,
    }}>
      <div style={{
        width: '100%', maxWidth: 360,
        background: 'var(--surface)', border: '1px solid var(--border)',
        borderRadius: 16, padding: 32, boxShadow: 'var(--shadow-lg)',
      }}>
        {/* Logo */}
        <div style={{textAlign:'center', marginBottom: 28}}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 56, height: 56, borderRadius: 14,
            background: 'var(--navy-900)', marginBottom: 12,
          }}>
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
              <circle cx="14" cy="14" r="12" stroke="#E63946" strokeWidth="2.5"/>
              <path d="M9 14h10M14 9v10" stroke="white" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <div style={{
            fontFamily: 'var(--font-display)', fontWeight: 800,
            fontSize: 20, letterSpacing: '-0.01em', color: 'var(--text)',
          }}>SCOUTING NEXUS</div>
          <div style={{fontSize: 12, color: 'var(--text-3)', marginTop: 4}}>
            Enter your access code to continue
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{
            animation: shake ? 'shake 0.5s ease' : 'none',
          }}>
            <input
              type="password"
              value={pin}
              onChange={e => { setPin(e.target.value); setError(false); }}
              placeholder="Access code"
              autoFocus
              style={{
                width: '100%', padding: '12px 14px',
                fontSize: 16, fontFamily: 'var(--font-mono)',
                letterSpacing: '0.15em', textAlign: 'center',
                background: 'var(--bg)', border: `1px solid ${error ? 'var(--red)' : 'var(--border)'}`,
                borderRadius: 10, color: 'var(--text)', outline: 'none',
                marginBottom: 8, boxSizing: 'border-box',
                transition: 'border-color 150ms',
              }}
            />
            {error && (
              <div style={{
                fontSize: 12, color: 'var(--red)', textAlign: 'center',
                marginBottom: 10, fontWeight: 600,
              }}>
                Incorrect access code
              </div>
            )}
          </div>
          <button type="submit" style={{
            width: '100%', padding: '12px 0',
            background: 'var(--navy-900)', color: '#fff',
            border: 'none', borderRadius: 10,
            fontSize: 13, fontWeight: 700, fontFamily: 'var(--font-display)',
            letterSpacing: '0.08em', cursor: 'pointer',
            marginTop: error ? 0 : 8,
            transition: 'opacity 150ms',
          }}>
            ENTER
          </button>
        </form>
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20%       { transform: translateX(-8px); }
          40%       { transform: translateX(8px); }
          60%       { transform: translateX(-6px); }
          80%       { transform: translateX(6px); }
        }
      `}</style>
    </div>
  );
}
